import { Box } from '@chakra-ui/react/box';
import { lazy, Suspense } from 'react';

import FileViewerSkeleton from './components/FileViewerSkeleton';
import { FileViewerProps } from './types/FileViewerProps';

const style = {
  height: '100%',
  '.monaco-editor .inputarea:focus-visible': {
    boxShadow: 'none',
  },
};

const FileViewerBody = lazy(() => import('./components/FileViewerBody'));
const FileViewer = (props: FileViewerProps) => (
  <Suspense fallback={<FileViewerSkeleton {...props} />}>
    <Box css={style}>
      <FileViewerBody {...props} />
    </Box>
  </Suspense>
);
export default FileViewer;
